import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { RequestForScanning } from "../../common/models/scan-documents.model";
import { FlowIndex } from "../../common/models/flow.dto";
import { WorkOrder } from "../../common/models/work-order.model";
import { FlowIndexSpec } from "../../flow/services/flow-instance.service";


@Injectable({
  providedIn: 'root'
})
export class ScanRequestService {

    private BASE_URL : string = "/api/docs";

    constructor(private client: HttpClient) { }

    createScanRequest(request: WorkOrder): Observable<FlowIndex> {
        return this.client.post<FlowIndex>(`${this.BASE_URL}/scan-request/create`, request);
    }

    getScanRequest(id: string): Observable<FlowIndex> {
        let spec = new FlowIndexSpec();
        spec.flowIdentifier = id;
        return this.client.get<FlowIndex[]>(`/api/flow-index?${this._buildQueryString(spec)}`).pipe(
            mergeMap((indicies: FlowIndex[]) => {
                if (indicies && indicies.length > 0) {
                    return of(indicies[0]);
                }
                return of(null);
            }));
    }

    updateScanRequest(targetState: string, currentOrderId: string, request: RequestForScanning): Observable<WorkOrder> {
        return this.client.post<WorkOrder>(`${this.BASE_URL}/update-scan-request/${currentOrderId}/${targetState}/`, request);
    }

    private _buildQueryString(criteria: FlowIndexSpec): string {

        let params = new URLSearchParams();
        if (criteria.organizationId) {
            params.set("orgId", criteria.organizationId);
        }

        if (criteria.flowIdentifier) {
            params.set("flowIdentifier", criteria.flowIdentifier);
        }

        if (criteria.isSubmitted !== undefined && criteria.isSubmitted !== null) {
            params.set("isSubmitted", criteria.isSubmitted.toString());
        }

        if (criteria.isInReview !== undefined && criteria.isInReview !== null) {
            params.set("isInReview", criteria.isInReview.toString());
        }

        if (criteria.isOnBehalf !== undefined && criteria.isOnBehalf !== null) {
            params.set("isOnBehalf", criteria.isOnBehalf.toString());
        }

        for (let i = 0; i < criteria.parts.length; i++) {
            let part = criteria.parts[i];

            if (part.templateId) {
                let prefix = `parts[${i}]`;
                params.set(prefix + ".templateId", part.templateId);
                if (part.inAnyState) {
                    params.set(prefix + ".inAnyState", part.inAnyState ? 'true' : 'false');
                }
                if (!part.inAnyState && part.states && part.states.length > 0) {
                    for (let j = 0; j < part.states.length; j++) {
                        let key = `${prefix}.states[${j}]`;
                        params.set(key, part.states[j]);
                    }
                }
            }
        }
        return params.toString();
    }
}
